import create from '../creator'
import axios from '@/wrapper'

const initialState = () => ({
  previousLog: null,
  log: null,
  previousError: null,
  error: null,
})
const _state = initialState()

const actions = {
  async logEvent({ commit, state, dispatch }, eventLog) {
    if (JSON.stringify(state.previousLog) === JSON.stringify(eventLog)) {
      return false
    }

    const data = {
      ...eventLog,
      system: 'PAYSID-v30',
      message: `__PAYSID__ ${eventLog.message}`,
    }

    commit('setPreviousLog', data)
    try {
      const resp = await axios.post(
        'v30/logging/event',
        data,
        {},
        { skipError: true }
      )
      commit('setLog', eventLog)

      return resp.data
    } catch (err) {
      dispatch('logError', {
        system: 'SIDv2.0 Website',
        message: `Status: ${err?.response?.status}, Message: Failed to LogProgress`,
      })
    }
    return false
  },

  async logError(
    { commit, dispatch },
    {
      transactionId = '',
      message = '',
      stackTrace = '',
      innerException = '',
      level = 'Error',
      skipError,
    }
  ) {
    const data = {
      transactionId: transactionId,
      level: level,
      system: process.env.VUE_APP_ENVIRONMENT,
      message: `${message}`,
      stackTrace: `${stackTrace}`,
      innerException: `${innerException}`,
    }

    commit('setPreviousError', data)
    try {
      const resp = await axios.post(
        'v30/logging/event',
        data,
        {},
        { skipError: true }
      )

      commit('setError', data)
      return resp.data
    } catch (err) {
      if (skipError) {
        return dispatch('logError', {
          system: 'SIDv2.0 Website',
          message: `Status: ${err?.response?.status}, Message: Failed to LogError`,
          skipError: true,
        })
      }
    }
    return false
  },
}

const mutations = {
  setPreviousLog(state, log) {
    state.previousLog = log
  },

  setLog(state, log) {
    state.log = log
  },

  setPreviousError(state, error) {
    state.previousError = error
  },

  setError(state, error) {
    state.error = error
  },
}

export default create(
  {
    namespaced: true,
    state: _state,
    actions,
    mutations,
  },
  initialState()
)
